<template>
  <popup ref="popup" :loading="popupLoading">
    <div slot="body">
      <el-form
        class="dataForm"
        ref="form"
        :disabled="disabled"
        :model="formParameter"
        :inline="true"
        label-width="80px"
        :rules="rules"
      >
        <el-row>
             <el-col :span="24">
            <el-form-item label="启用时间" prop="begin">
              <el-date-picker
                v-model="formParameter.begin"
                type="date"
                placeholder="选择日期"
                value-format="yyyy-MM-dd"
              ></el-date-picker>
            </el-form-item>
          </el-col> 
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="个人部分" prop="person"
              ><el-input
                v-model="formParameter.person"
                autocomplete="off"
              ></el-input
            ></el-form-item>
          </el-col>
         </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="公司部分" prop="cmpy"
              ><el-input
                v-model="formParameter.cmpy"
                autocomplete="off"
              ></el-input
            ></el-form-item>
          </el-col>
        </el-row>
        <el-row>
           <el-col :span="24">
            <el-form-item label="状态" prop="state"
              ><el-input
                v-model="formParameter.state"
                autocomplete="off"
              ></el-input
            ></el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div slot="footer">
      <el-button
        v-if="!disabled"
        type="primary"
        :loading="confirmLoading"
        @click="confirm()"
        >确 定</el-button
      >
      <el-button @click="close">取 消</el-button>
    </div>
  </popup>
</template>

<script>
import selectOptionDictionary from "@/components/biz/selectOptionDictionary/selectOptionDictionary.vue";
import popup from "@/components/popup/drawerPopup.vue";
import api from "@/api/cw/sebao.js";
export default {
  name: "edit",
  components: {
    popup,
    selectOptionDictionary,
  },
  data() {
    return {
      disabled: false,
      popupLoading: false,
      confirmLoading: false,
      parameter: {},
      formParameter: { state: "停用" },
      rules: {
        //启用时间
        begin: [
          {
            validator: this.$validate.required,
            trigger: "blur",
          },
        ],
        //状态：0停用,1启用
        state: [
          {
            validator: this.$validate.required,
            trigger: "blur",
          },
        ],
      },
    };
  },
  methods: {
    //打开弹框
    open(parameter, title, disabled, size) {
      this.parameter = parameter;
      this.disabled = disabled;
      this.$refs.popup.open(title, "35%");
      this.$nextTick(() => {
        this.init();
      });
    },
    //关闭弹框
    close() {
      this.disabled = false;
      this.$refs.popup.close();
    },
    //提交表单
    confirm() {
      this.$utils.checkForm(this.$refs.form, () => {
        this.confirmLoading = true;

        //添加
        let parameter = this.$utils.merger(this.formParameter);
        api.save(
          parameter,
          (response) => {
            this.$utils.msg.success(response.msg);
            this.confirmLoading = false;
            this.close();
            this.$parent.list();
          },
          (response) => {
            this.$utils.msg.warning(response.msg);
            this.confirmLoading = false;
          }
        );
      });
    },
    init() {
      this.popupLoading = true;
      //清除等待
      this.confirmLoading = false;
      //清空内容
      this.formParameter = { state: "停用" };
      //清楚校验
      this.$refs.form.clearValidate();
      //添加
      this.popupLoading = false;
    },
  },
};
</script>

<style lang="scss" scoped="scoped">
@import "~common/custom/css/common.scss";
@import "~common/custom/css/popup/popup.scss";
</style>
